.progressContainer {
  display: flex;
  border: 1px solid var(--colors-grays-ultralight);
  background: var(--colors-grays-ultralight);
  width: 100%;
  align-items: center;
  flex-direction: column;
  padding: 24px;
}

.title {
  margin-bottom: 16px;
}

.titleQualified {
  color: var(--colors-info-main);
}

.progressBar {
  height: 8px;
  border-radius: 12px;
  width: 100%;
  background: rgb(0 0 0 / 5%);
}

.progressFill {
  border-radius: 12px;
  height: 100%;
  background: var(--colors-info-main);
}

.currentProgress {
  margin-top: 8px;
}

.dealQualifiedBannerSection {
  margin-top: 24px;
  width: 100%;
}

@media all and (--reefer-media-tablet-min) {
  .progressContainer {
    border-radius: 20px;
    padding: 40px;
    margin-bottom: 16px;
  }

  .title {
    margin-bottom: 24px;
  }

  .dealQualifiedBannerSection {
    margin-top: 40px;
    width: 100%;
  }
}
